import MagentoLogo from "../images/platforms/magento-logo.png"
import Magento2Logo from "../images/platforms/magento2-logo.png"
import PrestashopLogo from "../images/platforms/prestashop-logo.png"
import ShopifyLogo from "../images/platforms/shopify_logo_black.png"
import WooCommerceLogo from "../images/platforms/woocommerce.png"
import { EProviderName } from "../types/provider/IProvider"
import { allPlatforms, TPlatformValue } from "../types/webshop/webshopdetails"
import { TPayment } from "./../types/payment/TPayment"

export interface IPlatform {
    text: string
    value: TPlatformValue
}

const platforms: IPlatform[] = [
    { text: "WooCommerce", value: "woocommerce" },
    { text: "Magento", value: "magento" },
    { text: "Magento 2", value: "magento2" },
    { text: "Shopify", value: "shopify" },
    { text: "Prestashop", value: "prestashop"}
]

export function getAvailablePlatforms() {
    return platforms
}

export function getAvailablePlatformsForPaymentType(paymentType: TPayment, provider?: EProviderName): TPlatformValue[] {
    switch (paymentType) {
        case "CreditCard":
            if (provider == "DankortEpay") {
                return ["woocommerce", "magento", "magento2", "prestashop"]
            }
            if (provider == "ForbrugsforeningenEpay") {
                return ["woocommerce", "magento", "magento2", "prestashop"]
            }
            return ["woocommerce", "magento", "magento2", "shopify", "prestashop"]
        case "MobilePayOnline":
            return ["woocommerce", "magento", "magento2", "shopify", "prestashop"]
        case "Vipps":
            return ["woocommerce", "magento2", "shopify", "prestashop"]
        case "Swish":
            return ["woocommerce", "magento", "magento2", "prestashop"]
        case "ApplePay":
            return ["woocommerce", "magento", "magento2", "prestashop"]
        case "KlarnaPayLater":
        case "KlarnaFinancing":
            return ["woocommerce", "magento", "magento2", "prestashop"]
        case "ResursInvoice":
        case "ResursPartPayment":
        case "ResursRevolvingCredit":
            return ["woocommerce", "magento", "magento2", "prestashop"]
        case "AccountToAccount":
            return ["woocommerce", "magento", "magento2", "prestashop"]
        case "Viabill":
            return ["woocommerce", "magento", "magento2"]
        case "Anyday":
            return ["woocommerce", "magento2"]
        case "Bancontact":
            return ["woocommerce", "magento2", "shopify", "prestashop"]
        case "Ideal":
            return ["woocommerce"]
        case "TermsTech":
            return ["magento2"]
        default:
            return []
    }
}

export function getPlatformLogo(platform: TPlatformValue | undefined) {
    if (!platform) {
        return undefined
    }

    switch (platform) {
        case "woocommerce":
            return WooCommerceLogo
        case "magento":
            return MagentoLogo
        case "magento2":
            return Magento2Logo
        case "prestashop":
            return PrestashopLogo
        case "shopify":
            return ShopifyLogo
    }
}

export function isPlatform(platform: string): boolean {
    return allPlatforms.map((p) => p + "").includes(platform)
}

export function getPlatformName(platform: TPlatformValue) {
    switch (platform) {
        case "woocommerce":
            return "WooCommerce"
        case "magento":
            return "Magento"
        case "magento2":
            return "Magento 2"
        case "prestashop":
            return "Prestashop"
        case "shopify":
            return "Shopify"
    }
}

export function getPlatformShortName(platform: TPlatformValue) {
    switch (platform) {
        case "woocommerce":
            return "Woo"
        case "magento":
            return "Mag1"
        case "magento2":
            return "Mag2"
        case "prestashop":
            return "Presta"
        case "shopify":
            return "Shfy"
    }
    return undefined
}

export function getPlatformColor(platform: TPlatformValue) {
    switch (platform) {
        case "woocommerce":
            return "plum"
        case "magento":
            return "lightsalmon"
        case "magento2":
            return "darkorange"
        case "prestashop":
            return "mediumvioletred"
        case "shopify":
            return "#95bf47"
    }
    return undefined
}
